// removed by extract-text-webpack-plugin
module.exports = {"cart":"c-Cart__cart","note":"c-Cart__note","overlay":"c-Cart__overlay","inner":"c-Cart__inner","header":"c-Cart__header","main":"c-Cart__main","footer":"c-Cart__footer","open":"c-Cart__open","overflowed":"c-Cart__overflowed","separator":"c-Cart__separator"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/Cart/Cart.scss
// module id = 891
// module chunks = 0